var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFireside(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 18,
    viewBox: "0 0 22 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94241 16.9026C5.2538 16.9026 5.47178 16.7526 5.83766 16.4053L8.10306 14.2658C7.66711 13.9105 7.309 13.35 7.309 12.0632V6.82895C7.309 4.40526 8.75699 2.96842 11.1469 2.96842H16.5963L16.5885 2.66842C16.4718 1.05 15.4208 0 13.6381 0H2.95727C1.17454 0 -0.000976562 1.08158 -0.000976562 2.96053V10.7132C-0.000976562 12.5921 1.17454 13.8 2.95727 13.8H4.24955V16.0974C4.24955 16.5868 4.50645 16.9026 4.94241 16.9026ZM17.5227 18C17.9665 18 18.2156 17.6763 18.2156 17.1947V14.8895H19.0408C20.8235 14.8895 21.999 13.6816 21.999 11.8105V7.01053C21.999 5.12368 20.8235 4.05 19.0408 4.05H11.326C9.46541 4.05 8.37553 5.12368 8.37553 7.01053V11.8105C8.37553 13.6816 9.46541 14.8895 11.326 14.8895H13.8171L16.6275 17.4947C16.9934 17.8421 17.2113 18 17.5227 18Z",
    fill: "#09090A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFireside);
export default __webpack_public_path__ + "static/media/icon-fireside.eef12646a5353762bc34778ce55fd78a.svg";
export { ForwardRef as ReactComponent };